'use client';

import { ArrowUp } from 'lucide-react';

export default function ScrollToTop() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className="inline-flex items-center gap-2 text-sm text-primary hover:underline transition-colors"
    >
      <ArrowUp className="h-4 w-4" />
      Back to top
    </button>
  );
}